//TODO: [AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
// quando confirmado a migração, remover refletir remoção do script nos trechos de código que utilizam ele,
// por enquanto só desabilitar.

declare global {
  interface Window {
    AnalyticsGJC: any;
  }
}

export const WIDGET_TYPES = {
  WHATSAPP: 'Whatsapp',
  CLASSI: 'Classi',
  EDICAO_DIGITAL: 'Edição Digital',
} as const;

type ObjectValues<T> = T[keyof T];

export type WidgetTypes = ObjectValues<typeof WIDGET_TYPES>;

export const sendAnalytics = (event, data) => {
  const userEmail = '';
  let copyObj = {};
  Object.assign(copyObj, data);
  cleanPageviewData(copyObj);
  // Caso seja o filtro de uma busca, ele deve remover alguns dados
  if (event == 'filtrar') {
    cleanPaginacao(copyObj);
    cleanData(copyObj);
  }
  let jsonAnalytics = {
    categoria: 'acao',
    tipo: event,
    dados: copyObj,
    email: userEmail ? userEmail : '',
    url: data.url,
    referrer: data.referrer,
  }
  if (window.AnalyticsGJC) {
    window.AnalyticsGJC.filaAnalyticsGJC.push(['enviarEvento', jsonAnalytics]);
  }
}

export const enviarPageView = (data) => {
  let jsonPageView = {};
  if (data) {
    jsonPageView = {
      url: data.url,
      contentId: data.contentId,
      referrer: data.referrer || '',
    }
  }
  window.AnalyticsGJC.filaAnalyticsGJC.push(['enviarPageView', jsonPageView]);
}

export const enviarClickCarregarMais = (descContentId, carregamento) => {
  sendAnalytics('click_carregar_mais', { descContentId, carregamento });
}

export const enviarClickWidget = (widget: WidgetTypes) => {
 sendAnalytics('click_widget', { widget });
}

export const enviarViewWidget = (widget: WidgetTypes) => {
 sendAnalytics('visualizacao_widget', { widget });
}

export const enviarClickItem = (itemName: string, local: string) => {
 sendAnalytics('click_item', { itemName, local });
}

export const enviarCardViewAnuncio = (idAnuncio: number) => {
 sendAnalytics('impressao_do_card_anuncio ', { idAnuncio });
}

export const enviarScroll = (porcentagem: number, contentId: string) => {
  let jsonAnalytics = {
    categoria: 'scroll',
    dados: { porcentagem },
    contentId,
    email: '',
    url: '',
    referrer: '',
  }

  if (window.AnalyticsGJC) {
    window.AnalyticsGJC.filaAnalyticsGJC.push(['enviarEvento', jsonAnalytics]);
  }
}

export const enviarViewTeaser = (local: string, tipoTeaser: string, pagina: number) => {
  sendAnalytics('visualizacao_teaser', { local, tipoTeaser, pagina });
}

export const enviarClickTeaser = (local: string, tipoTeaser: string, pagina: number) => {
  sendAnalytics('click_teaser', {local, tipoTeaser, pagina});
}

function cleanPaginacao(obj) {
  delete obj.pagina;
  delete obj.paginado;
  delete obj.qtdRegistros;
}

function cleanPageviewData(obj) {
  delete obj.url;
  delete obj.referrer;
}

function cleanData(obj) {
  for (let propName in obj) {
    if (typeof obj[propName] === 'object') {
      obj[propName] = cleanData(obj[propName]);
    }
  }
  return obj;
}

export const initAnalytics = (siteId, contentId, userEmail) => {
  if (typeof window === 'undefined') {
    return null
  }
  (function (window) {
    (function (w, d, s, e, t) {
      w.AnalyticsGJC = w.AnalyticsGJC || {}; w.AnalyticsGJC.filaAnalyticsGJC = w.AnalyticsGJC.filaAnalyticsGJC || [];
      // @ts-ignore
      e = d.createElement(s)
      // @ts-ignore
      e.type = 'text/java' + s
      // @ts-ignore
      e.async = 'async'
      // @ts-ignore
      e.src = 'https://s3-sa-east-1.amazonaws.com/analytics-gjc/analytics-gjc-min.js'
      // @ts-ignore
      t = d.getElementsByTagName(s)[0]
      // @ts-ignore
      t.parentNode.insertBefore(e, t)
    })(window, document, 'script')

    window.AnalyticsGJC.filaAnalyticsGJC.push(['definirContentId', contentId])
    window.AnalyticsGJC.filaAnalyticsGJC.push(['definirSiteId', siteId])
    userEmail && window.AnalyticsGJC.filaAnalyticsGJC.push(['definirUserEmail', userEmail])
  })(window)
}
